var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-row",
        [
          _c("b-col", [
            _c(
              "a",
              { staticClass: "btn btn-primary", attrs: { href: "/adm/rotas" } },
              [_c("i", { staticClass: "fa fa-map" }), _vm._v(" Voltar")]
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "row mt-3" }, [
        _c("div", { staticClass: "col-6" }, [
          _c("div", { staticClass: "card" }, [
            _c("div", { staticClass: "card-body" }, [
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c("label", [_vm._v("Início da Rota")]),
                  _vm._v(" "),
                  _c("date-picker", {
                    attrs: { config: _vm.datePickerConfig },
                    on: { "dp-change": _vm.onStartChange },
                    model: {
                      value: _vm.dtinicio,
                      callback: function($$v) {
                        _vm.dtinicio = $$v
                      },
                      expression: "dtinicio"
                    }
                  })
                ],
                1
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-6" }, [
          _c("div", { staticClass: "card" }, [
            _c("div", { staticClass: "card-body" }, [
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c("label", [_vm._v("Fim da Rota")]),
                  _vm._v(" "),
                  _c("date-picker", {
                    attrs: { config: _vm.datePickerConfig },
                    on: { "dp-change": _vm.onEndChange },
                    model: {
                      value: _vm.dtfim,
                      callback: function($$v) {
                        _vm.dtfim = $$v
                      },
                      expression: "dtfim"
                    }
                  })
                ],
                1
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _vm.listaRota.length > 0
        ? _c("div", { staticClass: "row mt-3" }, [
            _c("div", { staticClass: "col-12" }, [
              _c("div", { staticClass: "card" }, [
                _c("div", { staticClass: "card-body" }, [
                  _c("table", { staticClass: "table table-hover" }, [
                    _vm._m(0),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      _vm._l(_vm.orderedUsers, function(rota, i) {
                        return _c("tr", { key: i }, [
                          _c("td", { staticClass: "btn-group" }, [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-primary",
                                on: {
                                  click: function($event) {
                                    return _vm.removeRota(rota.id)
                                  }
                                }
                              },
                              [_c("i", { staticClass: "fas fa-trash" })]
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(rota.endereco))]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(rota.cidade))])
                        ])
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _c("tfoot", [
                      _c("tr", { staticClass: "text-primary" }, [
                        _c("td"),
                        _vm._v(" "),
                        _c("td", [_vm._v("Total Km " + _vm._s(_vm.totalKM))]),
                        _vm._v(" "),
                        _c("td")
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c("td"),
                        _vm._v(" "),
                        _c("td"),
                        _vm._v(" "),
                        _c(
                          "td",
                          [
                            _c(
                              "b-button",
                              {
                                attrs: { size: "sm", variant: "primary" },
                                on: { click: _vm.addRota }
                              },
                              [
                                _vm._v(
                                  "\n                                        Salvar Rota "
                                ),
                                _c("i", { staticClass: "fa fa-map-marker" })
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-button",
                              {
                                attrs: { size: "sm", variant: "info" },
                                on: {
                                  click: function($event) {
                                    return _vm.clearRotas()
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                                        Excluir Rota "
                                ),
                                _c("i", { staticClass: "far fa-trash-alt" })
                              ]
                            )
                          ],
                          1
                        )
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "row mt-3" }, [
        _c("div", { staticClass: "col-12" }, [
          _c("div", { staticClass: "card" }, [
            _c("div", { staticClass: "card-body" }, [
              _c("h3", { staticClass: "text-info" }, [
                _vm._v("Definindo rotas")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c("label", [_vm._v("Informe o endereço do Hotel.")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.busca,
                      expression: "busca"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text" },
                  domProps: { value: _vm.busca },
                  on: {
                    keyup: _vm.getAddress,
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.busca = $event.target.value
                    }
                  }
                }),
                _vm._v(" "),
                _vm.listaBusca.length > 0
                  ? _c(
                      "div",
                      { staticClass: "list-group" },
                      _vm._l(_vm.listaBusca, function(list, index) {
                        return _c(
                          "div",
                          { key: index, staticClass: "list-group-item" },
                          [
                            _c(
                              "a",
                              {
                                attrs: { href: "#" },
                                on: {
                                  click: function($event) {
                                    return _vm.addMarker(
                                      list.coordenadas,
                                      _vm.nomeHotel
                                    )
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(index + 1) +
                                    " - " +
                                    _vm._s(list.endereco)
                                )
                              ]
                            )
                          ]
                        )
                      }),
                      0
                    )
                  : _vm._e()
              ])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "mt-3" }, [
        _c(
          "div",
          { staticClass: "center-block col-md-12" },
          [
            _c(
              "l-map",
              {
                ref: "rota",
                staticStyle: { height: "400px" },
                attrs: { zoom: _vm.zoom, center: _vm.inicio }
              },
              [
                _c("l-tile-layer", {
                  attrs: { url: _vm.url, attribution: _vm.attribution }
                }),
                _vm._v(" "),
                _c("v-geosearch", { attrs: { options: _vm.geosearchOptions } }),
                _vm._v(" "),
                _vm._l(_vm.markers, function(marker) {
                  return _c(
                    "l-marker",
                    {
                      key: marker.id,
                      attrs: {
                        draggable: marker.draggable,
                        "lat-lng": marker.position
                      }
                    },
                    [_c("l-popup", { attrs: { content: marker.title } })],
                    1
                  )
                })
              ],
              2
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: { size: "xl", title: "Salvar Rota" },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function() {
                return [
                  _c(
                    "b-button",
                    {
                      attrs: { size: "sm", variant: "primary" },
                      on: { click: _vm.salvaRota }
                    },
                    [_vm._v("\n                Confirmar\n            ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      attrs: { size: "sm", variant: "danger" },
                      on: {
                        click: function($event) {
                          _vm.openModalRota = false
                        }
                      }
                    },
                    [_vm._v("\n                Cancelar\n            ")]
                  )
                ]
              },
              proxy: true
            }
          ]),
          model: {
            value: _vm.openModalRota,
            callback: function($$v) {
              _vm.openModalRota = $$v
            },
            expression: "openModalRota"
          }
        },
        [
          _c(
            "b-card",
            [
              _c("b-card-body", [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-md-12" }, [
                    _c("div", { staticClass: "list-group" }, [
                      _c("div", { staticClass: "list-group-item" }, [
                        _vm._v(
                          "\n                                Total de Combustível: R$ " +
                            _vm._s(_vm.totalCombustivel.toFixed(2)) +
                            "\n                                "
                        ),
                        _c("small", { staticClass: "text-danger" }, [
                          _vm._v(
                            "\n                                    " +
                              _vm._s(_vm.totalLitros.toFixed(2)) +
                              " Litros\n                                "
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "list-group-item" }, [
                        _vm._v(
                          "\n                                Total Hospedagem : R$ " +
                            _vm._s(_vm.totalHospedagem.toFixed(2)) +
                            "\n                                "
                        ),
                        _c("small", { staticClass: "text-danger" }, [
                          _vm._v(
                            "\n                                    " +
                              _vm._s(_vm.parametros.hospedagem) +
                              " a diária\n                                "
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "list-group-item" }, [
                        _vm._v(
                          "\n                                Total Alimentação : R$ " +
                            _vm._s(_vm.totalAlimentacao.toFixed(2)) +
                            "\n                                "
                        ),
                        _c("small", { staticClass: "text-danger" }, [
                          _vm._v(
                            "\n                                    " +
                              _vm._s(_vm.parametros.alimentacao) +
                              " a diária\n                                "
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "list-group-item bg bg-secondary" },
                        [
                          _vm._v(
                            "\n                                Total Pedágio : R$ " +
                              _vm._s(_vm.totalPedagio) +
                              "\n                            "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "list-group-item active" }, [
                        _vm._v(
                          "\n                                Total : R$ " +
                            _vm._s(
                              (_vm.valorTOTAL + _vm.totalPedagio).toFixed(2)
                            ) +
                            "\n                            "
                        )
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row mt-3" }, [
                  _c("div", { staticClass: "col-12" }, [
                    _c("table", { staticClass: "table table-hover" }, [
                      _c("thead", [
                        _c("tr", [
                          _c("th", [_vm._v("Rota")]),
                          _vm._v(" "),
                          _c("th", [_vm._v("Endereco")]),
                          _vm._v(" "),
                          _c("th", [_vm._v("Cidade")]),
                          _vm._v(" "),
                          _c("th", [_vm._v("Pedágio")]),
                          _vm._v(" "),
                          _c("th")
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "tbody",
                        _vm._l(_vm.orderedUsers, function(rota, i) {
                          return _c("tr", { key: i }, [
                            _c("td", [_vm._v(_vm._s(i + 1))]),
                            _vm._v(" "),
                            _c("td", [_vm._v(_vm._s(rota.endereco))]),
                            _vm._v(" "),
                            _c("td", [_vm._v(_vm._s(rota.cidade))]),
                            _vm._v(" "),
                            _c("td", [
                              _c("span", [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "mask",
                                      rawName: "v-mask",
                                      value: [
                                        "#.##",
                                        "##.##",
                                        "###.##",
                                        "###.##"
                                      ],
                                      expression:
                                        "['#.##', '##.##', '###.##', '###.##']"
                                    },
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: rota.pedagio,
                                      expression: "rota.pedagio"
                                    },
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: !rota.showInput,
                                      expression: "!rota.showInput"
                                    }
                                  ],
                                  attrs: { type: "text" },
                                  domProps: { value: rota.pedagio },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        rota,
                                        "pedagio",
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              ]),
                              _vm._v(" "),
                              rota.showInput
                                ? _c("span", [
                                    _vm._v(
                                      "\n                                            " +
                                        _vm._s(rota.pedagio) +
                                        "\n                                        "
                                    )
                                  ])
                                : _vm._e()
                            ]),
                            _vm._v(" "),
                            _c(
                              "td",
                              [
                                !rota.showInput
                                  ? _c(
                                      "b-button",
                                      {
                                        attrs: { variant: "success" },
                                        on: {
                                          click: function($event) {
                                            return _vm.addPedagio(
                                              rota.pedagio,
                                              i
                                            )
                                          }
                                        }
                                      },
                                      [_c("i", { staticClass: "fa fa-check" })]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                rota.showInput
                                  ? _c(
                                      "b-button",
                                      {
                                        attrs: { variant: "danger" },
                                        on: {
                                          click: function($event) {
                                            return _vm.addPedagio(0, i)
                                          }
                                        }
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "fas fa-window-close"
                                        })
                                      ]
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          ])
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _c("tfoot", [
                        _c("tr", { staticClass: "text-primary" }, [
                          _c("td", [_vm._v("-")]),
                          _vm._v(" "),
                          _c("td", [_vm._v("Total Km " + _vm._s(_vm.totalKM))]),
                          _vm._v(" "),
                          _c("td"),
                          _vm._v(" "),
                          _c("td"),
                          _vm._v(" "),
                          _c("td")
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Rota")]),
        _vm._v(" "),
        _c("th", [_vm._v("Endereco")]),
        _vm._v(" "),
        _c("th", [_vm._v("Cidade")])
      ])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bccab5c8", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bccab5c8","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/rotas/Rotas.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-bccab5c8","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/rotas/Rotas.vue
// module chunks = 2